export class Pos {
  id: number;
  commercialName: string;
  fiscalName: string;
  address?: string;
  lat?: number;
  lon?: number;
  openIndicator?: string;
  customer?: string;
  storeKey?: string;

  typePosSapCode?: string;
  typePosDescription?: string;
  tam?: string;
  nameTam?: string;
  idRDC?: string;
  nameRDC?: string;
  internalSales?: string;
  morningOpeningTime?: string;
  morningClosingTime?: string;
  afternoonOpeningTime?: string;
  afternoonClosingTime?: string;
  openingAdditionalInfo?: string;
  preferredTimeCall?: string;
  phone1?: string;
  phone1Print?: string;
  phone2?: string;
  phone2Print?: string;
  phone3?: string;
  phone3Print?: string;
  email1?: string;
  email1Print?: string;
  email2?: string;
  email2Print?: string;
  email3?: string;
  email3Print?: string;
  website?: string;
  contactIndicator?: string;
  shippingCity?: string;
  shippingCountry?: string;
  shippingPostalCode?: string;
  shippingState?: string;
  shippingStreet?: string;
  origin?: string;
  notVisible?: string;
  status?: string;
  idsfAccount?: string;

  constructor(id: number, commercialName: string, fiscalName: string) {
    this.id = id;
    this.commercialName = commercialName;
    this.fiscalName = fiscalName;
  }
}
